import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/privacy.html?raw";

export default function PrivacyPolicyPage() {
  return <TextLayout title="Privacy Policy" htmlContent={htmlContent} />;
}
